export default __webpack_public_path__ + "static/media/cross.41966756.svg";